import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrIsApplyingChanges = createSelector(
  [selectQbrState],
  ({ isApplyingChanges }) => isApplyingChanges
)
